import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=4fd4ea70"
import script from "./Tv.vue?vue&type=script&lang=ts"
export * from "./Tv.vue?vue&type=script&lang=ts"
import style0 from "./Tv.vue?vue&type=style&index=0&id=4fd4ea70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports